import classNames from 'classnames';
import * as React from 'react';

import css from './BooksSection.module.scss';

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  rightSide?: boolean;
  withPadding?: boolean;
}

const BooksSection = ({
  className,
  children,
  rightSide,
  withPadding,
}: Props) => {
  const classes = classNames(css.BooksSection, className, {
    [css.withPadding]: withPadding,
  });
  const contentClasses = classNames(css.BooksSection__Contents, {
    [css.isRightSide]: rightSide,
  });

  return (
    <div className={classes}>
      <div className={contentClasses}>{children}</div>
    </div>
  );
};

export default BooksSection;
